export const GET_ALL_USERS_START = 'GET_ALL_USERS_START'
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS'
export const GET_ALL_USERS_FAILED = 'GET_ALL_USERS_FAILED'
export const GET_DOMAIN_USERS_START = 'GET_DOMAIN_USERS_START'
export const GET_DOMAIN_USERS_SUCCESS = 'GET_DOMAIN_USERS_SUCCESS'
export const GET_DOMAIN_USERS_FAILED = 'GET_DOMAIN_USERS_FAILED'
export const GET_RECENTLY_VIEWED_DATA_START = 'GET_RECENTLY_VIEWED_DATA_START'
export const GET_RECENTLY_VIEWED_DATA_SUCCESS = 'GET_RECENTLY_VIEWED_DATA_SUCCESS'
export const GET_RECENTLY_VIEWED_DATA_FAILED = 'GET_RECENTLY_VIEWED_DATA_FAILED'
export const GET_RECENT_KEYWORDS_START = 'GET_RECENT_KEYWORDS_START'
export const GET_RECENT_KEYWORDS_SUCCESS = 'GET_RECENT_KEYWORDS_SUCCESS'
export const GET_RECENT_KEYWORDS_FAILED = 'GET_RECENT_KEYWORDS_FAILED'
export const GET_CALLER_USERS_START = 'GET_CALLER_USERS_START'
export const GET_CALLER_USERS_SUCCESS = 'GET_CALLER_USERS_SUCCESS'
export const GET_CALLER_USERS_FAILED = 'GET_CALLER_USERS_FAILED'
export const DELETE_USER_FROM_USER_MANAGEMENT_START = "DELETE_USER_FROM_USER_MANAGEMENT_START"
export const DELETE_USER_FROM_USER_MANAGEMENT_SUCCESS = "DELETE_USER_FROM_USER_MANAGEMENT_SUCCESS"
export const DELETE_USER_FROM_USER_MANAGEMENT_FAILED = "DELETE_USER_FROM_USER_MANAGEMENT_FAILED"
export const DELETE_DOMAIN_FROM_USER_ROLE_START = "DELETE_DOMAIN_FROM_USER_ROLE_START"
export const DELETE_DOMAIN_FROM_USER_ROLE_SUCCESS = "DELETE_DOMAIN_FROM_USER_ROLE_SUCCESS"
export const DELETE_DOMAIN_FROM_USER_ROLE_FAILED = "DELETE_DOMAIN_FROM_USER_ROLE_FAILED"